<template>
  <div class="controller-wrapper">
    <audio ref="audio">
      <source
          v-if="song!==null"
          v-bind:src="song.file"
          type="audio/mpeg">
      You browser does not support the audio tag
    </audio>
    <div class="controls-wrapper">
      <font-awesome-icon
          icon="backward"
          id="back"
          v-bind:class="{ inactive: index === 1}"
          v-on:click="$emit('prev-song')"
          class="control-btn"
      />
      <font-awesome-icon v-if="this.playing === false" icon="play" v-on:click="play" id="play" class="active control-btn"/>
      <font-awesome-icon
          v-if="this.playing === true"
          icon="pause"
          v-on:click="pause"
          id="pause"
          class="active control-btn"/>
      <font-awesome-icon
          icon="forward"
          id="next"
          v-bind:class="{ inactive: index === length }"
          v-on:click="$emit('next-song')"
          class="control-btn"
      />
      <!--</div>-->
      <!--<div class="progress-wrapper">-->
      <div id="progress">
        <div :style="{width: progressPercent + 'px'}"></div>
      </div>
      <!--<progress :value=progressPercent :max=100 id="progress"></progress>-->
      <span id="progress-value">{{duration_display}}</span>
    </div>
    <div class="volume-wrapper">
      <font-awesome-icon icon="volume-up"/>
      <input id="vol-control"
             type="range" value="1" min="0" max="1" step="0.01" title="volume"
             v-model.number="volumeValue"
             @change="volumeChange"
             class="control-btn"
      />
      <font-awesome-icon icon="list" v-on:click="$emit('toggle-playlist')" id="playlist" class="control-btn"/>
    </div>
  </div>
</template>

<script>
    export default {
        name: "Controller",
        data() {
            return {
                playing: false,
                time: 0,
                duration: 1,
                progressPercent: 0,
                duration_display: '00:00',
                volumeValue: 1,
            }
        },
        props: ['song', 'show', 'index', 'length'],
        methods: {
            convert: function () {
                try {
                    let hhmmss = new Date(this.duration * 1000).toISOString().substr(11, 8);
                    return hhmmss.indexOf("00:") === 0 ? hhmmss.substr(3) : hhmmss;
                } catch (e) {
                    return ''
                }
            },
            play: function () {
                this.$refs.audio.play();
                this.playing = true;
                this.duration = parseInt(this.audio.duration);
                this.duration_display = this.convert();
            },
            pause: function () {
                this.$refs.audio.pause();
                this.playing = false;
            },
            progressUpdate: function () {
                this.time = parseInt(this.audio.currentTime);
                this.progressPercent = parseInt(this.time / this.duration * 100);
                if (!this.duration_display) {
                    this.convert();
                }
            },
            volumeChange: function () {
                this.audio.volume = this.volumeValue;
            }
        },
        watch: {
            song: function () {
                this.$refs.audio.load();
                if (this.playing) {
                    this.play();
                }
            }
        },
        mounted() {
            this.audio = this.$el.querySelectorAll('audio')[0];
            this.audio.addEventListener('timeupdate', this.progressUpdate);
        }
    }

    // function SetVolume(value) {
    //     Console.log(value);
    // }
</script>

<style scoped lang="scss">

  .controller-wrapper {
    display: flex;
    justify-content: space-between;
    align-content: center;
    align-items: center;
  }

  #play, #pause {
    -webkit-border-radius: 50px;
    -moz-border-radius: 50px;
    border-radius: 50px;
    height: 50px;
    width: 50px;
    padding: 15px;
    margin: 0 15px;
    background-color: #354E61;
    color: #EFEFEA;
  }

  .inactive {
    color: #354E61;
  }

  #progress {
    flex-grow: 10;
    margin: 0 25px;
  }

  #vol-control {
    width: auto;
    padding: 0;
    margin: 15px;
  }

  #progress {
    background-color: #CECACA;
    border-radius: 13px;
    /* (height of inner div) / 2 + padding */
    padding: 1px;
  }

  #progress > div {
    background-color: #3A5060;
    /* Adjust with JavaScript */
    height: 5px;
    border-radius: 10px;
  }

  .progress {
    background-color: rgba(255, 255, 255, 0.4);
    height: 8px;
  }

  #progress-value {
    margin-right: 40px;
  }

  .form-control:focus {
    box-shadow: none;
  }

  #playlist {
    margin-left: 15px;
    height: 20px;
    width: 20px;
  }

  .controls-wrapper {
    width: 100%;
  }

  .volume-wrapper, .controls-wrapper, .progress-wrapper {
    display: flex;
    align-items: center;
  }

  @media (max-width: 767px) {
    .wrapper {
      flex-direction: column;
    }
  }

  .control-btn {
    cursor: pointer;
  }

</style>
